import React from 'react';
import { useSelector } from 'react-redux';
// @ts-ignore
import { Footer } from '@els/els-react--footer';
import { hasSucceeded } from '../../constants/async-status';
import {
    selectAppConfigs,
    selectAppConfigsAsyncStatus,
} from '../../features/app-config/app-config-selector';

const GeneralFooter = () => {
    const appConfigsAsyncStatus = useSelector(selectAppConfigsAsyncStatus);
    const appConfigs = useSelector(selectAppConfigs);

    const SUPPORT_HUB_HOME_URL =
        hasSucceeded(appConfigsAsyncStatus) &&
        Object.keys(appConfigs).length > 0
            ? appConfigs.SUPPORT_HUB_HOME_URL
            : '';
    return (
        <Footer
            className="general-footer"
            helpLink={SUPPORT_HUB_HOME_URL}
            shouldShowHelpLink
            legalEntity="Elsevier Inc."
            applicationLinks={[
                {
                    children: 'About Clinical Learning Hub',
                    href: 'https://www.elsevier.com/products/transition-to-practice',
                },
            ]}
        />
    );
};

export default GeneralFooter;
